import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from 'react';
import { AdvancedMarker as VisAdvancedMarker } from '@vis.gl/react-google-maps';
import { useReportBounds } from "../lib/BoundsRegistry";
function AdvancedMarkerInner({ position, title, imageUri, anchorCenter, zIndex, onClick, data }, ref) {
    useReportBounds(useMemo(() => position ? [position] : null, [position?.lat, position?.lng]));
    return (_jsx(VisAdvancedMarker, { ref: ref, position: position, title: title, zIndex: zIndex, anchorLeft: anchorCenter ? "-50%" : undefined, anchorTop: anchorCenter ? "-50%" : undefined, onClick: () => onClick?.(data), children: imageUri && _jsx("img", { src: imageUri, alt: title ?? '' }) }));
}
export const AdvancedMarker = forwardRef(AdvancedMarkerInner);
